<template>
  <b-modal
    hide-footer
    id="modal-notification"
    ref="modal-notification"
    size="xl"
    title="ยืนยันข้อมูล"
  >
    <div class="container">
      <b-card>
        <b-row>
          <b-col cols="12">
            <h4>รายการร้องทุกข์ใหม่รอดำเนินการ</h4>

            <CommonTable :rows="complaints" @handleSelect="onSelectChange">
            </CommonTable>
          </b-col>
        </b-row>
        <footer
          id="modal-transfer___BV_modal_footer_"
          class="modal-footer d-flex justify-content-between"
        >
          <button
            type="button"
            class="btn btn-secondary"
            block
            @click="onCancel"
          >
            ปิด
          </button>
          <button type="button" class="btn btn-primary" block @click="onSubmit">
            รับเรื่อง
          </button>
        </footer>
      </b-card>
    </div>
  </b-modal>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BModal,
  BButton,
  BFormTextarea,
  BCard,
} from "bootstrap-vue";

import vSelect from "vue-select";

import CommonTable from "./commonTableModal";

import * as screeningStore from "@/store/api/screening/screening.js";
import * as userData from "@/auth/localStorageUtils.js";

export default {
  components: {
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BButton,
    BModal,
    BFormTextarea,
    vSelect,
    CommonTable,
    BCard,
  },
  props: {
    complaints: {
      type: Array,
    },
    comment: {
      type: String,
      default: "",
    },
    person: {
      type: Object,
    },
  },
  data() {
    return {
      datasuggest: [],
      filteredOptions: [],
      inputProps: {
        id: "companyName",
        class: "form-control",
        placeholder: "ผู้ประกอบธุรกิจ (ผู้ถูกร้องทุกข์)",
      },
      limit: 10,
      selectComplaints: [],
    };
  },
  created() {},
  methods: {
    onSubmit() {
      const _this = this;

      if (this.selectComplaints.length < 1) {
        this.$bvToast.toast("กรุณาเลือกรายการ", {
          title: `กรุณาเลือกรายการอย่างน้อย 1 รายการ`,
          variant: "danger",
          solid: false,
        });
      } else {
        this.$swal({
          title: "ยืนยันการบันทึกข้อมูล?",
          text: "",
          icon: "success",
          showCancelButton: true,
          confirmButtonText: "บันทึก",
          cancelButtonText: "ยกเลิก",
          customClass: {
            confirmButton: "btn btn-primary",
            cancelButton: "btn btn-outline-primary ml-1",
          },
          buttonsStyling: false,
        }).then((result) => {
          if (result) {
            const complaintIds = this.selectComplaints.map(
              (value) => value.complaintId
            );

            //console.log('complaintIds', complaintIds)

            let userId;

            if (this.$route.query.id == null) {
              userId = userData.userId();
            } else {
              userId = this.$route.query.id;
            }

            const params = {
              complaintId: complaintIds,
            };

            screeningStore.postAdminComplaintRecieveDate((params)).then((response) => {
              console.log('reponse', response)

              if (response.data.success === true) {
                _this.$bvToast.toast("บันทึกข้อมูลสำเร็จ", {
                    title: `ระบบได้บันทึกการแก้ไขของท่านแล้ว`,
                    variant: "success",
                    solid: false,
                  });

                _this.$refs["modal-notification"].hide();
              }
              else {
                _this.$bvToast.toast("เกิดข้อผิดพลาด", {
                    title: `เกิดข้อผิดพลาดในการบันทึกข้อมูล`,
                    variant: "danger",
                    solid: false,
                  });
              }
            }).catch((error) => {
              console.log('error', error)
            })
          }
        });
      }
    },
    onCancel() {
      this.$refs["modal-notification"].hide();
    },
    onSelectChange(selects) {
      this.selectComplaints = selects;
      console.log("this.selectComplaints", this.selectComplaints);
    },
  },
};
</script>

<style></style>
